export default __webpack_public_path__ + "static/media/welfare_2025.d36fc859.jpg";